import React, { useContext, useCallback, MouseEventHandler } from 'react'
import TextLink from 'LuxKit/TextLink'
import ModalContext from 'contexts/ModalContext'
import CarHireItemSummaryLocationModal from 'components/Common/OrderView/OrderItemSummaries/CarHireItemSummary/CarHireItemSummaryLocationModal'

interface Props {
  sameLocation: boolean
  pickUpLocationName: string
  dropOffLocationName: string
  order: App.Order
}

export default function CarHirePurchaseSummaryLocation(props: Props) {
  const { sameLocation, pickUpLocationName, dropOffLocationName, order } = props

  const showModal = useContext(ModalContext)

  const onLocationModalClick = useCallback<MouseEventHandler<HTMLAnchorElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    const openTab = event.currentTarget.dataset.tab as ('Pick-up' | 'Drop-off')
    showModal(<CarHireItemSummaryLocationModal orderItem={order.carHireItems[0]} openTab={openTab} />)
  }, [order.carHireItems, showModal])

  return (
    <>
      {sameLocation && <>Pick-up & Drop-off at <TextLink onClick={onLocationModalClick}>{pickUpLocationName}</TextLink></>}
      {!sameLocation && <>
        Pick up at <TextLink data-tab="Pick-up" onClick={onLocationModalClick}>{pickUpLocationName}</TextLink>
        <div>
          Drop-off at <TextLink data-tab="Drop-off" onClick={onLocationModalClick}>{dropOffLocationName}</TextLink>
        </div>
      </>}
    </>
  )
}
